import { useEffect, useRef, useState } from 'react';

// Hides floating elements while the visitor is actively scrolling down (reading),
// and brings them back when scrolling up, near the top, or after a short pause.
export const useHideOnScroll = () => {
  const [hidden, setHidden] = useState(false);
  const lastY = useRef(0);
  const idle = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      if (y < 160) setHidden(false);
      else if (y > lastY.current + 6) setHidden(true);
      else if (y < lastY.current - 6) setHidden(false);
      lastY.current = y;
      clearTimeout(idle.current);
      idle.current = setTimeout(() => setHidden(false), 1100);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      clearTimeout(idle.current);
    };
  }, []);

  return hidden;
};
